import { render, staticRenderFns } from "./FTab.vue?vue&type=template&id=73d5f4c8&"
import script from "./FTab.vue?vue&type=script&lang=js&"
export * from "./FTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports